var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame35(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cross"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Close",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5491 5.44652L10.0191 7.97452L7.48905 5.44452C7.12623 5.06666 6.58741 4.91458 6.08056 5.04699C5.57371 5.17939 5.17811 5.57557 5.04645 6.08261C4.91479 6.58965 5.06766 7.12825 5.44606 7.49052L7.97505 10.0205L5.44806 12.5475C4.89839 13.1154 4.90566 14.0192 5.46439 14.5782C6.02311 15.1372 6.92687 15.1449 7.49505 14.5955L10.0191 12.0635L12.5471 14.5925C12.9101 14.9696 13.4486 15.1212 13.9551 14.9889C14.4616 14.8566 14.8572 14.4611 14.9895 13.9546C15.1218 13.4481 14.9702 12.9096 14.5931 12.5465L12.0691 10.0215L14.5961 7.49452C15.1457 6.92661 15.1385 6.02285 14.5797 5.46385C14.021 4.90485 13.1172 4.89714 12.5491 5.44652Z",
    fill: "currentColor"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame35);
export default __webpack_public_path__ + "static/media/Frame (35).4115a318d6f3b929eb955f47bdba9704.svg";
export { ForwardRef as ReactComponent };